import { Box, Button, Flex, Heading, Text } from '@chakra-ui/react';
import { Rating } from '@meritcircle/ui/components';
import useTranslation from 'next-translate/useTranslation';
import { rem } from 'polished';
import { ReviewRatingTotalProps } from './review-ratings-total.types';

export const ReviewRatingsTotal = ({
  rating,
  numberOfRatings,
  ctaHandler,
  userReviewed,
}: ReviewRatingTotalProps) => {
  const { t } = useTranslation('reviews');

  return (
    <Flex gap={{ base: 'space.12', sm: 'space.24' }} flexDirection={{ base: 'column', sm: 'row' }}>
      <Flex gap="space.24">
        {numberOfRatings ? (
          <Heading
            as="span"
            fontSize={{ base: '3xl', lg: '5xl' }}
            color="white"
            fontWeight="extrabold"
            letterSpacing="tight"
            lineHeight="1">
            {rating.toFixed(1)}
          </Heading>
        ) : null}
        <Flex flexDir="column" pt="space.8" gap={rem(10)}>
          <Rating rating={rating} showOnlyStars={true} size="lg" />
          <Box>
            <Text display="inline" size="md" color="desiredDawn" fontWeight={450}>
              {t('summary.total-rating', { count: numberOfRatings || 0 })}
            </Text>
          </Box>
        </Flex>
      </Flex>
      {!userReviewed && ctaHandler ? (
        <Button
          size="md"
          variant="primary"
          onClick={ctaHandler}
          my="space.4"
          mb="space.8"
          data-testid="game-write-a-review-button">
          {t('summary.cta')}
        </Button>
      ) : null}
    </Flex>
  );
};
